export default {
  EN: 'en',
  PT_BR: 'ptBR',
};
